<template>
	<v-container fluid>
		<v-row class="justify-center">
			<v-col cols="12" class="my-0 py-0">

				<v-row class="justify-center pt-2">
					<v-col cols="10" class="my-0 py-0 pt-4">
						<!--						advanced search filters-->
						<v-card>
							<v-form ref="form" class="mr-1 ml-1">
								<v-row class="pt-2">
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Τίτλος" dense v-model="criteria.title"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Υπότιτλος" dense v-model="criteria.subtitle"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Κωδικός Βιβλίου" v-model="criteria.id"
													  dense outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Συγγραφείς" dense v-model="criteria.authors"
													  outlined/>
									</v-col>
								</v-row>

								<v-row>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Αριθμός Έκδοσης" v-model="criteria.editionNumber"
													  dense outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Έτος Τρέχ. Έκδοσης" v-model="criteria.publicationYear"
													  dense outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Τίτλος τόμου" dense v-model="criteria.volumeTitle"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Αριθμός τόμου" dense v-model="criteria.volumeNumber"
													  outlined/>
									</v-col>
								</v-row>

								<v-row>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Λέξεις κλειδιά" dense v-model="criteria.keywords"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="ISBN" dense v-model="criteria.isbn"
													  outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-autocomplete class="primary-outline compact-field" label="Διαθέτης (Εκδότης)" :items="$store.getters.publishersForSelector.publisherList"
														dense outlined :loading="$store.getters.loadingPublishers" :disabled="$store.getters.loadingPublishers"
														item-value="id" item-text="name" v-model="criteria.publisherId"/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-text-field class="primary-outline compact-field" label="Εκδόσεις" dense v-model="criteria.editorialHouse"
													  outlined/>
									</v-col>
								</v-row>

								<v-row>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-select class="primary-outline compact-field" :items="typeSelector" dense
												  clearable v-model="criteria.type"
												  label="Τύπος" item-text="label" item-value="value"
												  @click:clear="criteria.type=null" outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-select class="primary-outline compact-field" v-model="criteria.finalizedByPublisher"
												  :items="finalizedByPublisherSelector" clearable dense
												  item-text="label" item-value="value" label="Ολοκληρωμένη Εγγραφή"
												  @click:clear="criteria.finalizedByPublisher=null" outlined/>
									</v-col>
									<v-col style="max-height: 30px" class="my-1 py-0" lg="3" md="6">
										<v-row justify="space-between">
											<v-col class="my-1 py-0 pb-2" cols="5">
												<v-btn @click="resetForm" block small outlined class="mt-2"
													   color="primary">Επαναφορά
													<v-icon>mdi-refresh</v-icon>
												</v-btn>
											</v-col>
											<v-col class="my-1 py-0 pb-2" cols="5">
												<v-btn @click="advancedSearchButton" block small outlined class="mt-2"
													   color="secondary">Αναζήτηση
													<v-icon>mdi-database-search-outline</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-form>
						</v-card>
					</v-col>
				</v-row>

				<!--				image that covers the page when no results -->
				<v-row class="justify-center pt-8" v-if="searchResults.length===0 && afterFirstSearch===false">
					<div class="mt-2" >
						<v-img :src="require('../assets/Eudoxus_Logo_RGB_Gr_Resize.png')"
							   style=" max-height:650px; max-width:650px;min-height:650px; min-width:650px" contain
							   alt=""></v-img>
					</div>
				</v-row>
				<v-row class="justify-center pt-8" v-if="searchResults.length===0 && afterFirstSearch===true">
					<div class="mt-2" >
						<h2 style="color: #DBDBDB">Δεν βρέθηκαν αποτελέσματα</h2>
					</div>
				</v-row>
				<!--				main result space -->
				<v-row class="justify-center pt-8" v-if="searchResults.length>0 && afterFirstSearch===true">
					<v-col xl="10" lg="10" md="8" sm="8">

						<SearchResults :search-results="searchResults" :image-cache="imageCache"/>

						<v-row justify="center" v-if="searchResults.length>0" class="mb-2">
							<div class="text-center">
								<v-pagination v-model="page"
											  :length="totalPages"
											  total-visible="10"
								></v-pagination>
							</div>
						</v-row>
					</v-col>
				</v-row>

			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import SearchResults from "./SearchResults";
	import requests from "../requests";
	import utils from '../utilities'
	export default {
		name: "AdvancedSearch",
		components: {SearchResults},
		data: () => ({
			page:1,
			totalPages:0,
			afterFirstSearch:false,
			noResults:false,
			criteria: {
				id: null,
				type: null,
				title: null,
				subtitle: null,
				authors: null,
				isbn: null,
				volumeTitle: null,
				volumeNumber: null,
				editionNumber: null,
				publicationYear: null,
				editorialHouse: null,
				publisherId: null,
				finalizedByPublisher: null,
				keywords: null,
			},

			finalizedByPublisherSelector: [
				{label: 'Ολοκληρωμένη', value: true},
				{label: 'Εκκρεμής', value: false}
			],
			typeSelector: [
				{label: 'Σύγγραμμα', value: 'Published'},
				{label: 'Ηλεκτρονικό Βιβλίο', value: 'eBook'},
				{label: 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις', value: 'ProfessorNotes'}
			],
			bookTypeValues: {
				'published': 'Σύγγραμμα',
				'ebook': 'Ηλεκτρονικό Βιβλίο',
				'professornote': 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις',
			},
			searchResults: [],
			defaultCover: require('../assets/blank.png'),
			imageCache:{},
		}),

		methods:{

			resetForm() {
				this.$refs.form.reset()
			},

			advancedSearchButton() {
				this.page = 1;
				this.advancedSearch();
			},

			test(){
				console.log(this.searchResults.length)
				console.log(this.afterFirstSearch)
			},

			advancedSearch() {
				document.activeElement.blur();
				this.$store.commit('setLoadingModal', true);
				//deserialization issues
				if (this.criteria.keywords != null && this.criteria.keywords.trim() === '') {
					this.criteria.keywords = null;
				}

				let reqObj = JSON.parse(JSON.stringify(this.criteria));
				if (this.criteria.keywords!=null  && this.criteria.keywords!==''){
					let keywordsArray = this.criteria.keywords
						.replace(/,/g, ' ')
						.split(' ')
						.map(kw => kw.trim())
						.filter(kw => kw.length > 0);
					reqObj.keywords = keywordsArray;
				}


				reqObj.first = (this.page -1)*9;// bad name but it's used in too many places to change it // paging starts from 0 but the vue component from 1
				reqObj.pageSize = 9;
				requests.put('rest/app/advanced-search', reqObj, this.searchCallBack);
			},


			searchCallBack(resp) {

				this.$store.commit('setLoadingModal', false);
				this.processSearchResults(JSON.parse(JSON.stringify(resp.results)));
				this.afterFirstSearch = true;

				if(resp.results.length===0){
					this.noResults = true;
				}

				// this.page = resp.start+1;
				this.totalPages = Math.floor(resp.total / 9);
				if (resp.total % 9 > 0) {
					this.totalPages++;
				}
			},

			async processSearchResults(books) {
				for (const book of books) {
					const cover = await this.getCover(book.pathToCover);
					this.$set(this.imageCache, book.id, cover);
				}
				this.searchResults = books;
			},

			async getCover(pathToCover) {
				const url = utils.reformatBookPath(pathToCover)
				console.log(url);
				return new Promise((resolve) => {
					const img = new Image();
					img.onload = () => resolve(url);
					img.onerror = () => resolve(this.defaultCover);
					img.src = url;
				});
			},

		},

		watch: {
			'page': function (val) {
				if (this.$store.getters.simpleSearch === true) {
					this.simpleSearch();
				} else {
					this.advancedSearch();
				}
			},
		}

	}
</script>

<style scoped>
	.col-class {
		font-size: medium;
		font-weight: bold
	}


	.light-grey-outline.v-text-field.v-text-field--outlined >>> fieldset {
		border-color: #DBDBDB;
	}

	.primary-outline.v-text-field.v-text-field--outlined >>> fieldset {
		border-color: #11254D;
	}

	.text-white >>> input {
		color: #DBDBDB !important;
	}

	.text-white >>> label {
		color: #DBDBDB !important;
	}


	.compact-field >>> .v-input__control {
		min-height: 28px !important;
	}

	.compact-field >>> .v-input__slot {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		margin-bottom: 0 !important;
		min-height: 24px !important;
	}

	/* input in v-text-field text */
	.compact-field >>> input {
		height: 24px !important;
		line-height: 24px !important;
		font-size: 13px !important;
		padding-top: 2px !important;
		padding-bottom: 4px !important;
		margin-top: 2px !important;
		margin-bottom: 0 !important;
	}

	/* Selections inside v-select and v-autocomplete */
	.compact-field >>> .v-select__selections {
		height: 24px !important;
		line-height: 24px !important;
		font-size: 13px !important;
		padding-top: 0 !important; /* fine-tune this value for vertical alignment */
		padding-bottom: 6px !important;
		margin-top: 0 !important;
		margin-bottom: 6px !important;
	}

	/* label positioning */
	.compact-field >>> .v-label {
		top: 2px !important;
		line-height: 24px !important;
		font-size: 13px !important;
	}

	/* dropdown icon (v-icon) vertical alignment */
	.compact-field >>> .v-input__append-inner {
		margin-top: 0 !important;
		height: 24px !important;
		display: flex;
		align-items: center;
	}
	.custom-chip:hover {
		background-color: white !important;
		color: white !important;
		border-color: white !important;
	}

	.checkbox-list {
		max-height: 120px;
		overflow-y: auto;
	}

	/* --- Chrome / Edge --- */
	.checkbox-list::-webkit-scrollbar {
		width: 10px;               /* scrollbar thickness */
	}

	.checkbox-list::-webkit-scrollbar-track {
		background: transparent;   /* track background */
	}

	.checkbox-list::-webkit-scrollbar-thumb {
		background-color: #11455B; /* Vuetify primary */
		border-radius: 9999px;     /* full pill shape */
		border: 2px solid transparent;
		background-clip: content-box;
	}

	/* hide scrollbar buttons (up/down arrows) */
	.checkbox-list::-webkit-scrollbar-button {
		display: none !important;
		width: 0 !important;
		height: 0 !important;
	}

	.checkbox-list .v-list-item {
		min-height: 28px !important; /* default is ~48px */
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}

	.checkbox-list .v-input--checkbox {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
</style>